import React, { useRef, useState } from "react";

import Icon from "../Icon";

export default function EntryExplanation({ explanationUrl, onFetchRef }) {
  const [explanation, setExplanation] = useState(null);
  const [loading, setLoading] = useState(false);
  const [limitResetsInDays, setLimitResetsInDays] = useState(null);
  const pollRef = useRef(null);

  const fetchExplanation = () => {
    if(!explanationUrl || loading) return;
    setLimitResetsInDays(null);
    setLoading(true);

    $.ajax({ method: "get", url: explanationUrl })
      .done((data) => {
        if(data.explanation) {
          setExplanation(data.explanation);
          setLoading(false);
          return;
        }
        $.ajax({ method: "post", url: explanationUrl })
          .done(() => {
            pollRef.current = setInterval(() => {
              $.ajax({ method: "get", url: explanationUrl })
                .done((pollData) => {
                  if(pollData.explanation) {
                    clearInterval(pollRef.current);
                    setExplanation(pollData.explanation);
                    setLoading(false);
                  }
                });
            }, 2000);
            setTimeout(() => { clearInterval(pollRef.current); setLoading(false); }, 30000);
          })
          .fail((jqXHR) => {
            const quota = jqXHR.responseJSON?.user;
            if(quota) setLimitResetsInDays(quota.monthResetsInDays);
            setLoading(false);
          });
      })
      .fail(() => setLoading(false));
  };

  if(onFetchRef) onFetchRef.current = fetchExplanation;

  if(loading) return <div className="text-muted small" style={{ marginTop: 6 }}><Icon name="refresh" /> Loading explanation...</div>;
  if(limitResetsInDays !== null) return <div className="text-muted small" style={{ marginTop: 6 }}>You've used all your explanations this month. Resets in {limitResetsInDays} days.</div>;
  if(explanation) return <div className="well well-sm small" style={{ marginTop: 6, whiteSpace: "pre-wrap" }}>{explanation}</div>;
  return null;
}
